import { ObjectVacationsParams } from '../../types/ParamsTypes';
import { AxiosResponse } from 'axios';
import { getAxiosWithConfig } from '../Http/HttpService';
import { ObjectVacationsResponse } from '../../types/ObjectVacationTypes';

export const fetchObjectVacations = async (
  objectVacationsParams: ObjectVacationsParams,
): Promise<AxiosResponse<ObjectVacationsResponse>> => {
  try {
    const instance = getAxiosWithConfig();

    return instance.post('plugin', {
      plugin: 'booking',
      data: {
        module: 'objectVacations',
        params: objectVacationsParams,
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};
